import { D } from "@tanstack/react-query-devtools/build/legacy/ReactQueryDevtools-ChNsB-ya";
import {Skeleton} from "primereact/skeleton";

const VacationSkeleton = () => {
    const VACATION_COUNT = 4;

    const getItems = () => {
        const items = [];
        for (let i = 0; i < VACATION_COUNT; i++) {
            items.push(
                <Skeleton key={i} class-name="w-full" height="9rem" />
            );
        }
        return items;
    };

    return (
        <div className="flex flex-column pt-5 px-3 gap-3 pb-6 align-items-center h-full">
            <div className="w-full flex flex-column justify-content-center gap-3">
            {getItems()}
            </div>
        </div>
    );
};

export default VacationSkeleton;

